interface IPropsLiquidez {
  criSobrePl: number | null | undefined;
  caixaSobrePl: number | null | undefined;
  passivoSobreAtivo: number | null | undefined;
}

// Nunca renderiza NaN/Infinity: quando o divisor é 0/nulo o valor vem
// como null e é exibido como "—".
const formatPercent = (val: number | null | undefined) =>
  val === null || val === undefined || !Number.isFinite(val)
    ? '—'
    : `${val.toFixed(2).replace('.', ',')}%`;

export const Liquidez = ({
  criSobrePl,
  caixaSobrePl,
  passivoSobreAtivo,
}: IPropsLiquidez) => {
  const alavancado = typeof criSobrePl === 'number' && Number.isFinite(criSobrePl) && criSobrePl > 100;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '.5rem',
          flexWrap: 'wrap',
        }}
      >
        <strong
          style={{
            fontSize: '2rem',
            lineHeight: 1.1,
            color: '#111827',
            fontWeight: 700,
          }}
        >
          {formatPercent(criSobrePl)}
        </strong>
        {alavancado && (
          <span
            style={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#FF4D4F',
              background: '#FFF1F0',
              border: '1px solid #FFA39E',
              borderRadius: '999px',
              padding: '2px 8px',
              lineHeight: 1.2,
            }}
          >
            ALERTA · Fundo alavancado
          </span>
        )}
      </div>
      <span style={{ fontSize: '12px', color: '#9CA3AF' }}>
        CRI / Patrimônio líquido
      </span>

      <div
        style={{
          display: 'flex',
          gap: '1rem',
          flexWrap: 'wrap',
          marginTop: '.25rem',
        }}
      >
        <div>
          <span style={{ fontSize: '11px', color: '#9CA3AF', display: 'block' }}>
            Caixa / PL
          </span>
          <strong style={{ fontSize: '.9rem', color: '#111827' }}>
            {formatPercent(caixaSobrePl)}
          </strong>
        </div>
        <div>
          <span style={{ fontSize: '11px', color: '#9CA3AF', display: 'block' }}>
            Passivo / Ativo
          </span>
          <strong style={{ fontSize: '.9rem', color: '#111827' }}>
            {formatPercent(passivoSobreAtivo)}
          </strong>
        </div>
      </div>
    </div>
  );
};
